import types from '../../constants';
import auth from '../../auth';
import moment from 'moment';
import download2 from '../../assets/js/download';

function download(content, fileName, contentType) {
  var a = document.createElement("a");
  var file = new Blob([content], {type: contentType});
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
}

export function fetchCompanies() {
  return async (dispatch) => {
    dispatch({ type: types.COMPANIES_FETCH_START });
    fetch('/api/companies', {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.json();
      })
      .then((data) => {
        dispatch({
          type: types.COMPANIES_FETCH_END,
          payload: data.companies,
        });
      })
      .catch(err => console.log(err)); // eslint-disable-line

    return true;
  };
}

export function exportAll() {
  return async (dispatch) => {
    dispatch({ type: types.COMPANIES_FETCH_START });
    fetch('/api/companies/export-all', {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.blob();
      })
      .then(blob => {
        dispatch({
          type: types.COMPANIES_FETCH_FAILED,
        });

        let title = `export-${new moment().format('MM-DD-YYYY')}.zip`;
        download2(blob, title, 'application/zip');

      })

  }
}


export function exportCompanies(companies) {
  return async (dispatch) => {
    dispatch({ type: types.COMPANIES_FETCH_START });
    let body = JSON.stringify({companies});
    fetch('/api/companies/export', {
      method: 'POST',
      body,
      headers: {
        Accept: 'application/zip',
        Authorization: localStorage.token,
        'Content-Type': 'application/json'
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.blob();
      })
      .then(blob => {
        dispatch({
          type: types.COMPANIES_FETCH_FAILED,
        });

        let title = `export-${new moment().format('MM-DD-YYYY')}.zip`;
        download2(blob, title, 'application/zip');

      })

  }
}


export function deleteCompanies(companies) {
  return async (dispatch) => {
    if (confirm("Are you sure you want to delete selected companies, users, scenarios and all related simulations files")) {
      dispatch({type: types.COMPANIES_FETCH_START});
      let body = JSON.stringify({companies});
      fetch('/api/companies/delete-companies', {
        method: 'DELETE',
        body,
        headers: {
          pragma: 'no-cache',
          Accept: 'application/json',
          Authorization: localStorage.token,
          'Content-Type': 'application/json'
        },
      })
        .then((response) => {
          if (response.status === 403 || response.status === 401) {
            auth.logoutAndRedirect();
            throw new Error('Not authenticated.');
          }

          return response.blob();
        })
        .then(blob => {
          dispatch({
            type: types.COMPANIES_FETCH_FAILED,
          });
          alert('Companies were successfully deleted');
        })
        .then(() => {
          setTimeout(() => {
            fetchCompanies()(dispatch)
          }, 500)
        })
    }
  }
}


export function importFile(file) {
  return async (dispatch) => {
    dispatch({ type: types.COMPANIES_FETCH_START });

    let body = new FormData();
    body.append('importFile', file);
    fetch('/api/companies/import', {
      method: 'POST',
      body,
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          alert('Successfully imported');
        }
        if (response.status === 400) {
          alert('Bad import file.');
        }
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        dispatch({
          type: types.COMPANIES_FETCH_FAILED,
        });
      })
      .then(() => {
        setTimeout(() => {
          fetchCompanies()(dispatch)
        }, 500)
      })

  }
}


export function changeFilter(key, value) {
  return {
    type: types.COMPANIES_CHANGE_FILTER,
    payload: {
      key,
      value,
    },
  };
}

export function resetFilter() {
  return { type: types.COMPANIES_RESET_FILTER };
}
